import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials:true 
});



export default axiosInstance;
